import React, { useState } from 'react';
import Styles from './styled';
import Dropdown from '../Inputs/Dropdown';
import FileTextIcon from '../Icons/FileText';

const filesLookup = [
  {
    label: 'Alabama',
    value: 'AL',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Arizona',
    value: 'AZ',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(AZ).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(AZ).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(AZ).pdf',
    },
    fileName: 'Loan Application Package - Arizona',
  },
  {
    label: 'Arkansas',
    value: 'AR',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(AR-GA-NC).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package - Arkansas',
  },
  {
    label: 'California',
    value: 'CA',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(CA).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(CA).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(CA).pdf',
    },
    fileName: 'Loan Application Package - California',
  },
  {
    label: 'Colorado',
    value: 'CO',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(CO).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(CO).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(CO).pdf',
    },
    fileName: 'Loan Application Package - Colorado',
  },
  {
    label: 'Delaware',
    value: 'DE',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(DE).pdf',
      buy: '/resources/documents-forms/Loan-Application-Package-(DE).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(DE).pdf',
    },
    fileName: 'Loan Application Package - Delaware',
  },
  {
    label: 'Florida',
    value: 'FL',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Georgia',
    value: 'GA',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(AR-GA-NC).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(AR-GA-NC).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(AR-GA-NC).pdf',
    },
    fileName: 'Loan Application Package - Georgia',
  },
  {
    label: 'Idaho',
    value: 'ID',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Illinois',
    value: 'IL',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(IL).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(IL).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(IL).pdf',
    },
    fileName: 'Loan Application Package - Illinois',
  },
  {
    label: 'Indiana',
    value: 'IN',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Kansas',
    value: 'KS',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Kentucky',
    value: 'KY',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Louisiana',
    value: 'LA',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Maryland',
    value: 'MD',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Michigan',
    value: 'MI',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Mississippi',
    value: 'MS',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(MS).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(MS).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(MS).pdf',
    },
    fileName: 'Loan Application Package - Mississippi',
  },
  {
    label: 'Missouri',
    value: 'MO',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Nevada',
    value: 'NV',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'New Mexico',
    value: 'NM',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(NM).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(NM).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(NM).pdf',
    },
    fileName: 'Loan Application Package - New Mexico',
  },
  {
    label: 'North Carolina',
    value: 'NC',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(AR-GA-NC).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(AR-GA-NC).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(AR-GA-NC).pdf',
    },
    fileName: 'Loan Application Package - North Carolina',
  },
  {
    label: 'Ohio',
    value: 'OH',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Oklahoma',
    value: 'OK',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(OK).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(OK).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(OK).pdf',
    },
    fileName: 'Loan Application Package - Oklahoma',
  },
  {
    label: 'Oregon',
    value: 'OR',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(OR).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(OR).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(OR).pdf',
    },
    fileName: 'Loan Application Package - Oregon',
  },
  {
    label: 'Pennsylvania',
    value: 'PA',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'South Carolina',
    value: 'SC',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(SC).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(SC).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(SC).pdf',
    },
    fileName: 'Loan Application Package - South Carolina',
  },
  {
    label: 'Tennessee',
    value: 'TN',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Texas',
    value: 'TX',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(TX).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(TX).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(TX).pdf',
    },
    fileName: 'Loan Application Package - Texas',
  },
  {
    label: 'Utah',
    value: 'UT',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package',
  },
  {
    label: 'Virginia',
    value: 'VA',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(VA).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(VA).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(VA).pdf',
    },
    fileName: 'Loan Application Package - Virginia',
  },
  {
    label: 'Washington',
    value: 'WA',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package ',
  },
  {
    label: 'West Virginia',
    value: 'WV',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package ',
  },
  {
    label: 'Wyoming',
    value: 'WY',
    file: {
      origination:
        '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
      buy: '/resources/documents-forms/Express-Lending-Package-(All-Other-States).pdf',
      sell: '/resources/documents-forms/Loan-Application-Package-(All-Other-States).pdf',
    },
    fileName: 'Loan Application Package ',
  },
];

const Component = ({ type = 'origination', children }) => {
  const [state, setState] = useState('');
  const files = filesLookup
    .filter(({ file: fileList }) => fileList[type])
    .map(({ label, value }) => ({
      label,
      value: label,
    }));
  const file = filesLookup.find(
    ({ label }) => label.toLowerCase() === state.toLowerCase()
  );

  const handleChange = ({ value }) => {
    const isOptionClick = !!filesLookup.find(
      ({ value: fileValue }) => fileValue === value
    );

    setState(value);

    if (isOptionClick) {
      setTimeout(() => {
        document.activeElement.blur();
      }, 100);
    }
  };

  return (
    <Styles className='block-loan_application_package'>
      {children && <div className='content'>{children}</div>}
      <div className='dropdown'>
        <div className='row'>
          <Dropdown
            value={state}
            onChange={handleChange}
            label='State'
            values={files}
            showFormatted={false}
          />
        </div>
        {file && (
          <div className='result'>
            <a href={file.file[type]} target='_blank' rel='noopener noreferrer'>
              <FileTextIcon />
              {file.fileName}
            </a>
          </div>
        )}
      </div>
    </Styles>
  );
};

Component.propTypes = {};

export default Component;
